// -- Get URL Parameter function
function getURLParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');

  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam) {
      sParameterName[1] = sParameterName[1].replace('+',' ');
      return decodeURIComponent(sParameterName[1]);
    }
  }
}


// -- Google Conversion
function cmg_google_conversion(sDoGoogleConversion, iConversionId, sImageHtml) {
  //set this to FALSE to skip all of the code in this function (instead of deleting the actual code sample)
  var bDoGoogleConversion = false;
  if (sDoGoogleConversion == 'On') { bDoGoogleConversion = true; }

  if (bDoGoogleConversion) {
    var google_conversion_id = iConversionId;
    var google_custom_params = window.google_tag_params;
    var google_remarketing_only = true;

    //inject the 1 pixel image onto the page, thus calling the Google tracking
    $('body').append(sImageHtml);
  }

  return true;
}


/**
 * Google reCaptcha
 */
var recaptchas = function() {
  $(function(){
    $('[data-recaptcha]').each(function(){
      var $this = $(this);

      grecaptcha.render($(this).get(0), {
        sitekey: $(this).data('sitekey'),
        callback: function(response) {
          if (response) {
            $this.parents('form').submit();
            $this.after('<button type="submit" class="'+($this.attr('class').replace('g-recaptcha ',''))+'">' + $this.text() + '</button>').remove();
          }
        }
      });
    });
  });
};


/**
 * Defer loading css styles until after page load
 */
var loadDeferredStyles = function() {
  var addStylesNode = document.getElementById("deferred-styles");
  if (addStylesNode != null) {
    var replacement = document.createElement("div");
    replacement.innerHTML = addStylesNode.textContent;
    document.body.appendChild(replacement);
    addStylesNode.parentElement.removeChild(addStylesNode);
  }
};

var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

if (raf) raf(function() { window.setTimeout(loadDeferredStyles, 0); });
else window.addEventListener('load', loadDeferredStyles);


var htmlOverflow = function(element) {
  if (element.is(':visible')) {
    $('html').css('overflow','hidden');
  }
  else {
    $('html').css('overflow','');
  }
};


// -- Used for IE to replace btoa function
function encode64(input) {
  var keyStr = "ABCDEFGHIJKLMNOP" +
    "QRSTUVWXYZabcdef" +
    "ghijklmnopqrstuv" +
    "wxyz0123456789+/" +
    "=";
  input = escape(input);
  var output = "";
  var chr1, chr2, chr3 = "";
  var enc1, enc2, enc3, enc4 = "";
  var i = 0;

  do {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);

    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
       enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
       enc4 = 64;
    }

    output = output +
      keyStr.charAt(enc1) +
      keyStr.charAt(enc2) +
      keyStr.charAt(enc3) +
      keyStr.charAt(enc4);
    chr1 = chr2 = chr3 = "";
    enc1 = enc2 = enc3 = enc4 = "";
  } while (i < input.length);

  return output;
}


function alertMessage($type, $message) {
  var $alert = $('#alert');
  if ($alert.length) {
    $alert.addClass('alert--' + $type).text($message).slideDown();
    setTimeout(function() {
      $alert.slideUp(function() {
        $alert.removeClass('alert--' + $type).text('');
      });
    }, 3000);
  }
}


function scriptLoader(deferredScripts) {
  if (deferredScripts && typeof $ != 'undefined') {
    if (deferredScripts.head && Array.isArray(deferredScripts.head) && deferredScripts.head.length) {
      $('head').append(deferredScripts.head.join(''));
    }

    if (deferredScripts.body && Array.isArray(deferredScripts.body) && deferredScripts.body.length) {
      deferredScripts.body.forEach(function(script){
        $('body').prepend(deferredScripts.body.join(''));
      });
    }

    if (deferredScripts.footer && Array.isArray(deferredScripts.footer) && deferredScripts.footer.length) {
      deferredScripts.footer.forEach(function(script){
        $('body').append(deferredScripts.footer.join(''));
      });
    }
  }
}

(function($) {
  'use strict';

  if ($('html').hasClass('page-employment')) {

    var apply = {
      domCache: function() {
        // -- Form
        this.$file            = $('#file');
        this.$fileName      = $('#file-name-preview');
        this.$fileToggle     = $('#file-toggle');
        this.$applyForm      = $('#apply-form');

        // -- Job Single View
        this.$applyFormWrap = $('#apply-form-wrap');
        this.$showApplyForm = $('#show-apply-form');
      },

      file: function() {
        var self = this;

        this.$file.change(function(){
          var filename = $(this).val().split(/(\\|\/)/g).pop();
          self.$fileName.html(filename).slideDown(100);
        });

        this.$fileToggle.click(function(e){
          e.preventDefault();
          self.$file.trigger('click');
        });
      },

      applyForm: function() {
        var self = this;

        this.$applyForm.formulate({
          require: 'First Name, Last Name, Email{email}, Resume',
          errorClass: 'form__field--error',
          showOnSubmit: '',
          ajax: false,
          fireOnError: function() {
            $(document).find('.form__field--error').siblings('[data-infield-label]').addClass('form__label--error');
            if (self.$file.hasClass('form__field--error')) {
              $('.form__row--file').addClass('form__row--error');
            } else {
              $('.form__row--file').removeClass('form__row--error');
            }
          }
        });
      },

      toggleForm: function() {
        var self = this;
        this.$showApplyForm.click(function(e){
          e.preventDefault();
          self.$applyFormWrap.slideToggle(200);
        });
      },

      init: function() {
        this.domCache();
        this.file();
        this.applyForm();
        this.toggleForm();
      }
    };

    $(function() {
      apply.init();
    });

  }

})(jQuery);

(function($) {
  'use strict';

  if ($('html').hasClass('page-communities')) {

    var community = {
      domCache: function() {
        this.$community     = $('#community');
        this.$loading       = $('#loading');
        this.$filterForm    = $('#filter-form');
        this.$moreFilters   = $('#more-filters');
        this.$filterQuery   = $('#filter-input');
        this.$hiddenFilters = $('[data-js-hook="hidden-filter-row"]');
        this.$tab           = $('[data-js-hook="tab"]');
        this.$tabMap        = $('#tab-map');
        this.$tabList       = $('#tab-list');
        this.$filterView    = $('#filter-view');
        this.$mapCanvas     = $('#map_canvas');
        this.$columnLeft    = $('#column-left');
        this.$columnRight   = $('#column-right');
        this.$filterResults = $('#filter-results-container');
      },

      filter: function() {
        var self = this;
        var interval = {
          instance: null,
          count: 0,
          limit: 30,
          interval: 100
        };

        // -- Listen for form submission and respond
        this.$filterForm.on('submit', function(){
          interval.instance = setInterval(function(){
            if (self.$filterForm.data('complete') || interval.count === interval.limit) {
              clearInterval(interval.instance);
            }
            interval.count = interval.count + 1;
          }, interval.interval);
        });

        // -- Expand Filters
        this.$moreFilters.click(function(e){
          e.preventDefault();
          self.$hiddenFilters.slideToggle(200);
        });

        // -- Look for `query` value on load and prompt form submission
        this.$filterQuery.on('keyup', function() {
          if (self.$filterQuery.val() !== '') {
            self.$filterForm.submit();
          }
        });
      },

      tabs: function() {
        var self = this;

        this.$tab.click(function(e){
          e.preventDefault();
          var activeClass = 'community__tab-link--active';
          var view = $(this).data('js-view');

          // -- Toggle active tab state
          self.$tab.removeClass(activeClass);
          $(this).addClass(activeClass);

          // -- Inject new `view` value and re-submit form
          self.$filterView.val(view);
          self.$filterForm.submit();

          // -- Remove map & add classes where needed
          if (view === 'list') {
            self.$columnLeft.hide();
            self.$mapCanvas.hide();
            self.$columnRight.addClass('community__column--slim');
            self.$filterResults.addClass('community__listing--stretch');
          } else {
            self.$columnLeft.show();
            self.$mapCanvas.show();
            self.$columnRight.removeClass('community__column--slim');
            self.$filterResults.removeClass('community__listing--stretch');
          }
        });
      },

      mobileViewSwap: function(width) {
        var self = this;
        var viewSwitched = false;
        $(window).on('load resize', function(){
          if ($(window).width() <= width) {
            if (!viewSwitched) {
              self.$tabList.trigger('click');
              viewSwitched = true;
            }
          } else {
            viewSwitched = false;
          }
        });
      },

      init: function() {
        this.domCache();
        this.filter();
        this.tabs();
        this.mobileViewSwap(1180);
      }
    };

    $(function() {
      community.init();
    });

  }

})(jQuery);

/* -----------------------------------------------------------------
  CONFIG ELEMENT HELPER
----------------------------------------------------------------- */
function _e(selector) {
  return new jonahConfig.element._instance(selector);
}

/* -----------------------------------------------------------------
  CONFIG OBJECT
----------------------------------------------------------------- */
var jonahConfig = {
  siteUrl: config.siteUrl,
  mobileBreak: 808
};

/* -----------------------------------------------------------------
  CONFIG WOW OBJECT
  Remove when migrating jonahConfig object to site not using WOW for
  animations.
----------------------------------------------------------------- */
if (typeof WOW == 'function') {
  jonahConfig.wowInit = function() {
    jonahConfig.wow = new WOW();
    jonahConfig.wow.destroy = function() {
      $('.wow').removeClass('wow');
    }
  }();
}

/* -----------------------------------------------------------------
  CONFIG REQUEST OBJECT
----------------------------------------------------------------- */
jonahConfig.request = {
  _cache: [],

  _request: function(type, url, dataOrCallback, callback, dataType) {

    if (dataOrCallback instanceof Object || typeof dataOrCallback == 'string') {
      var data = dataOrCallback;
    } else {
      var data = false;
      console.log(dataOrCallback);
      callback = dataOrCallback;
    }

    var cacheIndex = data ? type + ':' + url + '?' + $.param(data) : type + ':' + url;
    var cache = this._cache[cacheIndex];

    if (cache) {
      callback(cache, {fromCache: true, cacheIndex: cacheIndex});
    } else {
      $.ajax({
        type: type,
        url: url,
        data: data,
        success: function(data) {
          jonahConfig.request._cache[cacheIndex] = data;
          callback(data, {fromCache: false, cacheIndex: cacheIndex});
        },
        dataType: dataType,
        cache: false
      });
    }
  },

  post: function(url, dataOrCallback, callback, dataType) {
    this._request("POST", url, dataOrCallback, function(data, cached){
      callback(data, cached);
    }, dataType);
  },

  get: function(url, dataOrCallback, callback, dataType) {
    this._request("GET", url, dataOrCallback, function(data, cached){
      callback(data, cached);
    }, dataType);
  },

  load: function(element, url, dataOrCallback, callback, dataType, type) {
    type = type || "GET";
    _e(element).ready(function($element){
      jonahConfig.request._request(type, url, dataOrCallback, function(data, cached){
        $element.html(data);
        callback(data, cached);
      }, dataType);
    }, 300);
  },
};

/* -----------------------------------------------------------------
  CONFIG ELEMENT
----------------------------------------------------------------- */
jonahConfig.element = {
  _instances:  {},

  _instance: function(selector) {
    var self = this;
    this.sliding = false;

    if (selector instanceof jQuery) {
      this.selector = selector;
    } else {
      this.selector = $(selector);
    }

    this.ready = function(callback, timeout) {
      $(function(){
        var interval;
        var loop = 0;
        interval = setInterval(function(){
          ++loop;
          if (self.selector.length || (timeout && loop == timeout)) {
            if (self.selector.length) {
              callback(self.selector);
            }
            clearInterval(interval);
          }
        }, 50);
      });
    }

    this.load = function(url, dataOrCallback, callback, dataType, type) {
      jonahConfig.request.load(self.selector, url, dataOrCallback, function(data, cached){
        callback(data, cached);
      }, dataType, type);
    }

    this.toggleText = function(object){
      self.ready(function($element){
        $element.text(object.onCondition ? object[1] : object[0]);
      });
    }

    this.centerScreenOn = function(scrollSpeed){
      scrollSpeed = scrollSpeed || 200;
      self.ready(function($element){
        $('html, body').animate({
          scrollTop: $element.offset().top - $(window).height()/2 + $element.outerHeight()/2
        }, scrollSpeed);
      });
    }

    this.slideFadeDown = function(speed, callback) {
      speed = speed || 200;
      self.ready(function($element){
        if (!$element.is(':visible')) {
          $element
            .css('opacity', 0)
            .slideDown(speed)
            .animate({ opacity: 1 }, {
              queue: false,
              duration: speed,
              complete: callback
            });
        }
      });
    }

    this.slideFadeUp = function(speed, callback) {
      speed = speed || 200;
      self.ready(function($element){
        if ($element.is(':visible')) {
          $element
            .css('opacity', 1)
            .slideUp(speed)
            .animate({ opacity: 0 }, {
              queue: false,
              duration: speed,
              complete: callback
            });
          }
      });
    }

    this.slideFadeToggle = function(speed, callback) {
      self.ready(function($element){
        if (!self.sliding) {
          self.sliding = true;
          if ($element.is(':visible')) {
            self.slideFadeUp(speed, function(){
              self.sliding = false;
              if (callback) {
                callback();
              }
            });
          } else {
            self.slideFadeDown(speed, function(){
              self.sliding = false;
              if (callback) {
                callback();
              }
            });
          }
        }
      });
    }
  }
}

/* -----------------------------------------------------------------
  CONFIG LOCATION OBJECT
----------------------------------------------------------------- */
jonahConfig.location = {
  current: window.location.pathname.substr(1) ? window.location.pathname.substr(1).replace(/\/$/, '') : 'index',
  root: window.location.pathname.split('/')[1],
  queryString: window.location.search,

  isRoot: function(root) {
    return root.replace(/(\/$|^\/)/g, '') === this.root;
  },

  isPage: function(current) {
    return current.replace(/(\/$|^\/)/g, '') === this.current;
  },

  getQueryString: function(string) {
    if (!window.location.search) {
      return false;
    }

    if (string) {
      var query = this.queryString;
    } else {
      var query = [];
      this.queryString.replace(/(^\?)/, '').split('&').forEach(function(param){
        param = param.split('=');
        query[decodeURIComponent(param[0])] = decodeURIComponent(param[1]);
      });
    }
    return query;
  },

  getParam: function(param) {
    var queries = this.getQueryString();
    param = param.trim();
    return (param && queries && queries[param]) ? queries[param] : false;
  }
};

/* -----------------------------------------------------------------
  CONFIG SCREEN OBJECT
----------------------------------------------------------------- */
jonahConfig.screen = {
  _resizeCallbacks: [],
  _resize: function() {
    $(window).on('load resize', function(){
      var windowWidth = $(window).width();
      jonahConfig.screen.size = windowWidth;
      if (jonahConfig.screen._resizeCallbacks.length) {
        jonahConfig.screen._resizeCallbacks.forEach(function(callback){
          callback(windowWidth);
        });
      }
    });
  }(),

  /*
    @var size | Int
    Current width of window. Adjusts as browser resizes.
  */
  size: $(window).width(),

  /*
    @method onResize
    @param callback | Function(windowWidth)

    Define a function to perform on window resize.
  */
  onResize: function(callback) {
    jonahConfig.screen._resizeCallbacks.push(callback);
  },

  /*
    @method atSize
    @param size | Int
    @param callback | Function

    Define a function to perform when the window size is exactly
    the size passed to the first position.
  */
  atSize: function(size, callback) {
    jonahConfig.screen.onResize(function(windowWidth){
      if (windowWidth === size) {
        callback(windowWidth);
      }
    });
  },

  /*
    @method whenSmallerThan
    @param size | Int
    @param callback | Function

    Define a function to perform ONCE when the window size becomes
    smaller than the size passed to the first position.
  */
  whenSmallerThan: function(size, callback) {
    var callbackFired = false;
    jonahConfig.screen.onResize(function(windowWidth){
      if (windowWidth < size) {
        if (!callbackFired) {
          callback(windowWidth);
          callbackFired = true;
        }
      } else {
        callbackFired = false;
      }
    });
    return this;
  },

  /*
    @method whileSmallerThan
    @param size | Int
    @param callback | Function

    Define a function to perform while the window size is
    smaller than the size passed to the first position.
  */
  whileSmallerThan: function(size, callback) {
    jonahConfig.screen.onResize(function(windowWidth){
      if (windowWidth < size) {
        callback(windowWidth);
      }
    });
    return this;
  },

  /*
    @method whenLargerThan
    @param size | Int
    @param callback | Function

    Define a function to perform ONCE when the window size becomes
    larger than the size passed to the first position.
  */
  whenLargerThan: function(size, callback) {
    var callbackFired = false;
    jonahConfig.screen.onResize(function(windowWidth){
      if (windowWidth > size) {
        if (!callbackFired) {
          callback(windowWidth);
          callbackFired = true;
        }
      } else {
        callbackFired = false;
      }
    });
    return this;
  },

  /*
    @method whileLargerThan
    @param size | Int
    @param callback | Function

    Define a function to perform while the window size is
    larger than the size passed to the first position.
  */
  whileLargerThan: function(size, callback) {
    jonahConfig.screen.onResize(function(windowWidth){
      if (windowWidth > size) {
        callback(windowWidth);
      }
    });
    return this;
  }
};

/* -----------------------------------------------------------------
  CONFIG EMAIL OBJECT
----------------------------------------------------------------- */
jonahConfig.email = {
  elements: $('[data-mail-name]'),

  _convert: function($element) {
    var email = $element.data('mail-name') + '@' + $element.data('mail-host');
    $element.attr('href', 'mailto:' + email);
    if ($element.text() === '') {
      $element.text(email);
    }
    else if ($element.text().indexOf("{") >= 0) {
      var text = $element.html();
      text = text.replace(/{(.*?)}/, email);
      $element.html(text);
    }
    $element.removeAttr('data-mail-name');
    $element.removeAttr('data-mail-host');
  },

  mailToInject: function(el) {
    if (el) {
      jonahConfig.email._convert(el);
    } else {
      jonahConfig.email.elements.each(function(){
        jonahConfig.email._convert($(this));
      });
    }
  }
};

/* -----------------------------------------------------------------
  MAIL TO INJECT INIT
----------------------------------------------------------------- */
jonahConfig.email.mailToInject();

(function($) {
  'use strict';

  var forms = {
    dom: function() {
      // -- Infield Label
      this.$infieldLabels = $('[data-infield-label]');

      // -- Pick A Date
      this.$datePicker    = $('[data-js-hook="pickadate"]');

      // -- Form Stuff
      this.$formLoader    = $('#form-loading');
      this.$contactForm   = $('#contact-form');
      this.$tourForm      = $('#schedule-a-tour-form');
    },

    infieldLabels: function() {
      this.$infieldLabels.inFieldLabels();
    },

    pickadate: function() {
      this.$datePicker.pickadate();
    },

    forms: function() {
      var self = this;

      // -- Validate the form
      this.$contactForm.formulate({
        require: 'First Name, Last Name, Email{email}, Comments',
        errorClass: 'form__field--error',
        showOnSubmit: '#contact-confirm',
        inlineMsg: true,
        inlineMsgClass: 'form__inline-error',
        fireOnSubmit: function() {
          self.$formLoader.fadeIn(200);
        },
        fireOnSuccess: function() {
          self.$formLoader.fadeOut(200);
          cmg_google_conversion($('#contact_us_conversion').val(), $('#contact_us_conversion_id').val(), $('#contact_us_conversion_html').val());
        },
        fireOnError: function(){
          self.$formLoader.fadeOut(200);
          $(document).find('.form__form-field--error').siblings('[data-infield-label]').addClass('form__label--error');
        }
      });

      // -- Validate the form
      this.$tourForm.formulate({
        require: 'First Name, Last Name, Email{email}, Phone',
        errorClass: 'form__field--error',
        showOnSubmit: '#schedule-a-tour-confirm',
        inlineMsg: true,
        inlineMsgClass: 'form__inline-error',
        fireOnSubmit: function() {
          self.$formLoader.fadeIn(200);
        },
        fireOnSuccess: function() {
          self.$formLoader.fadeOut(200);
          cmg_google_conversion($('#schedule_tour_conversion').val(), $('#schedule_tour_conversion_id').val(), $('#schedule_tour_conversion_html').val());
        },
        fireOnError: function(){
          self.$formLoader.fadeOut(200);
          $(document).find('.form__form-field--error').siblings('[data-infield-label]').addClass('form__label--error');
        }
      });
    },

    ready: function() {
      this.dom();
      this.infieldLabels();
      this.pickadate();
      this.forms();
    }
  };

  $(function() { forms.ready(); });

})(jQuery);

(function($) {
  'use strict';

  if ($('html').hasClass('page-home-page')) {

    var index = {
      domCache: function() {
        this.$header       = $('#header');
        this.$hero         = $('#hero');
        this.$video        = $('#homeVideo');
        this.$rotator      = $('#rotator');
        this.$aboutButton  = $('#expand-button');
        this.$aboutBody    = $('#about-hidden');
        this.$searchForm   = $('#index-search-form');
        this.$searchSubmit = $('#index-search-submit');
        this.$searchClear  = $('#index-search-clear');
        this.$searchInput  = $('#index-search-input');
      },

      hero: function() {
        var self = this;
        var width = $(window).width();

        $(window).on('load resize', function(event) {
          if (!self.$hero.hasClass('homepage__hero--default')) {
            var offsetTimeout;
            var offset = 0;

            if (!siteSettings.overlayHeader) {
              offset = self.$header.outerHeight();
            }

            if (event.type == 'load') {
              offsetTimeout = setTimeout(function() {
                self.$hero.height($(window).height() - offset);
              }, 300);
            }
            else if (offsetTimeout) {
              clearTimeout(offsetTimeout);
            }

            if ($(window).width() != width) {
              width = $(window).width();
              self.$hero.height($(window).height() - offset);
            }
          }
        });
      },

      video: function() {
        var self = this;

        if (self.$video.length) {
          var video = self.$video[0];
          var $fallback = $('.homepage__video-fallback');

          // -- Remove video if taking too long to load
          setTimeout(function() {
            if (video.readyState < 3) {
              console.info('Connection too slow. Replacing video with static image');
              $fallback.show();
              video.pause(0);
              video.src = '';
              if (video.childNodes && $(video.childNodes[1]).length > 0) {
                video.childNodes[1].src = '';
              }
              video.load();
              video.childNodes[1].remove();
              self.$video.remove();
            }
          }, 1500);

          Modernizr.on('videoautoplay', function(result) {
            if (!result) {
              if (self.$video.length) {
                if ('playsInline' in document.createElement(self.$video.attr('id'))) {
                  return false;
                }
                else {
                  if (video.play() === undefined) {
                    video.remove();
                    $fallback.show();
                  }
                }
              }
            }
          });
        }
      },

      rotator: function() {
        this.$rotator.addClass('flexslider').flexslider({
          controlNav: true,
          directionNav: false,
          // -- Comment out Controls Container if
          // -- you intend to use controlNav
          controlsContainer: '.flex-direction-nav-container'
        });
      },

      about: function() {
        this.$aboutButton.click(function(e){
          e.preventDefault();
          this.$aboutBody.slideToggle(100);
        });
      },

      indexSearch: function() {
        var self = this;

        this.$searchInput.on('input', function(){
          if ($(this).val() === "") {
            self.$searchClear.hide();
          } else {
            self.$searchClear.show();
          }
        });

        this.$searchSubmit.click(function(e){
          e.preventDefault();
          self.$searchForm.submit();
        });

        this.$searchClear.click(function(e){
          e.preventDefault();
          self.$searchInput.val('');
          self.$searchClear.hide();
        });
      },

      init: function() {
        this.domCache();
        this.hero();
        this.video();
        this.rotator();
        this.about();
        this.indexSearch();
      }
    };

    $(document).ready(index.init());

  }

})(jQuery);

(function($) {
  'use strict';

  var init = {
    domCache: function() {
      // -- Misc
      this.$html     = $('html');
      this.$body     = $('body');
      this.$htmlBody = $('html, body');

      this.$headerToolbar = $('#headerToolbar');
      this.$page          = $('#page');
      this.$email         = $('[data-mail-name]');
      this.$petLink       = $('[data-js-hook="pet-policy"]');
      this.$petPolicy     = $('#pet-policy-flyout');

      // -- Mobile Nav
      this.$hamburger = $('#hamburger');
      this.$mobileNav = $('#mobile-nav');

      // -- Sidebar
      this.$sidebarToggle     = $('#sidebar-toggle');
      this.$sidebarToggleText = $('#sidebar-toggle-text');
      this.$sidebarToggleIcon = $('#sidebar-toggle-icon');
      this.$sidebarNav        = $('#sidebar-nav');

      // -- Filter
      this.$filterForm     = $('#filter-form');
      this.$filterLoading  = $('#filter-loading');
      this.$filterSelect   = $('[data-js-hook="filter-select"]');
      this.$filterResults  = $('#filter-results-container');
      this.$filterInput    = $('#filter-input');
      this.$filterClear    = $('#filter-clear');
      this.$filterClearAll = $('#filter-clear-all');
      this.$filterToggle   = $('#filter-toggle');
      this.$clearFilters   = $('#clear-all');

      this.$citySelect = $('select[id="city"]');

      if (this.$citySelect.length) {
        this.cityOptions = this.$citySelect.html();
      }

      // -- Other Shtuff
      this.$lightbox = $('[data-js-hook="swipebox"]');
    },

    mobileNav: function() {
      var self = this;
      this.$hamburger.click(function(e){
        e.preventDefault();
        self.$html.toggleClass('menu-open');
        self.$mobileNav.slideToggle(200);
      });
    },

    header: function() {
      var self = this;
      var offset = self.$headerToolbar.outerHeight();

      $(window).on('load scroll', function() {
        var scrollTop = $(window).scrollTop();

        if (scrollTop >= offset) {
          self.$html.addClass('stuck');
        }
        else {
          self.$html.removeClass('stuck');
        }
      });
    },

    sidebar: function() {
      var self = this;
      this.$sidebarToggle.click(function(e){
        e.preventDefault();
        self.$sidebarNav.slideToggle(100, function(){
          var sidebarToggleText = self.$sidebarNav.is(':visible') ? 'Hide Menu' : 'Show Menu';
          var sidebarToggleIcon = self.$sidebarNav.is(':visible') ? '-' : '+';
          self.$sidebarToggleText.text(sidebarToggleText);
          self.$sidebarToggleIcon.text(sidebarToggleIcon);
        });
      });
    },

    pagination: function() {
      var self = this;
      // -- Cache DOM here since we re-call self.pagination()
      // -- in `load` callback and need to re-cache nodes.
      this.$pagination = $('#pagination');
      this.$paginationLink = $('#pagination').find('a');
      this.$paginationLink.click(function(e){
        e.preventDefault();
        $(self.$pagination.data('load-in')).load($(this).attr('href'), {}, function(){
          self.$htmlBody.animate({scrollTop: self.$page.offset().top});
          self.pagination();
        });
      });
    },

    filter: function() {
      var self = this;
      var timeout;

      // -- Filter Form Submit
      this.$filterForm.submit(function(e){
        e.preventDefault();
        var values = false;

        self.$filterLoading.fadeIn(200);

        if (self.$filterInput.val() !== '') {
          values = true;
        }

        self.$filterSelect.each(function(select){
          if ($(self.$filterSelect[select]).val() != null && $(self.$filterSelect[select]).val().length) {
            values = true;
          }
        });

        if (values) {
          self.$filterClearAll.fadeIn(200);
        }
        else {
          self.$filterClearAll.fadeOut(200);
        }

        self.$filterForm.data('complete', false);
        self.$filterResults.load($(this).attr('action'), $(this).serialize(), function() {
          self.$filterForm.data('complete', true);
          setTimeout(function(){
            self.$filterLoading.fadeOut(200);
          }, 200);
        });
      });

      // -- Filter Select Change
      this.$filterSelect.change(function() {
        // -- Pre-filter city select based on selected state
        if (self.$citySelect.length) {
          var aCityOptions;
          var selectedCity = '';

          if ($(this).attr('name') == 'state') {
            if (self.$citySelect.val()) {
              selectedCity = self.$citySelect.val();
            }
            if ($(this).val()) {
              var state = $(this).val();
              aCityOptions = '<option value="">Any City</option>';
              $.each(locations[state], function(i, cities) {
                $.each(cities, function(i, city) {
                  aCityOptions += '<option value="'+city+'"'+(selectedCity == city ? ' selected' : '')+'>'+city+'</option>';
                });
              });
              self.$citySelect.html(aCityOptions);
            }
            else {
              self.$citySelect.html(self.cityOptions);
            }
          }
        }

        self.$filterForm.submit();
      });

      // -- Filter While Typing
      this.$filterInput.on('input', function(){
        var val = $(this).val().trim();

        if (val === '') {
          self.$filterForm.submit();
          self.$filterClear.hide();
          self.$filterInput.removeClass('filter__field--has-value');
        } else {
          self.$filterClear.show();
          self.$filterInput.addClass('filter__field--has-value');
          clearTimeout(timeout);
          timeout = setTimeout(function(){
            self.$filterLoading.fadeIn(200);
            self.$filterForm.submit();
          }, 600);
        }
      });

      // -- Filter Clear
      this.$filterClear.click(function(e){
        e.preventDefault();
        self.$filterClear.hide();
        self.$filterInput.val('');
        self.$filterForm.submit();
      });

      this.$filterClearAll.click(function(e){
        e.preventDefault();
        self.$filterInput.val('');
        self.$filterClear.hide();
        self.$filterSelect.each(function(select){
          $(self.$filterSelect[select]).val('');
        });
        self.$filterForm.submit();
      });

      // -- Filter Toggle Mobile
      this.$filterToggle.click(function(e){
        e.preventDefault();
        self.$filterToggle.slideUp(200);
        self.$filterForm.slideDown(200);
      });
    },

    petPolicy: function() {
      var main = this;

      this.$petLink.click(function(e){
        e.preventDefault();
        $(this).toggleClass('background-primary svg-primary');
        main.$petPolicy.fadeToggle();
      });
    },

    lazyLoad: function() {
      if ($('.lazy-load').length) {
        $('.lazy-load').lazyload();
      }
    },

    lightbox: function() {
        this.$lightbox.swipebox({
          hideBarsDelay: false,
          removeBarsOnMobile: false,
          loopAtEnd: true,
          afterOpen: function(){
            // -- Trigger close event on #swipebox-container click event.
            $('#swipebox-container').click(function(e){
              e.preventDefault();
              $('#swipebox-close').trigger('click');
            });
            // -- Wait for image to load after open, then bind click events
            // -- to disable propogation from certain elements.
            var interval;
            interval = setInterval(function(){
              if ($('#swipebox-slider .slide.current img').length) {
                clearInterval(interval);
                $('#swipebox-top-bar, #swipebox-slider .slide.current img').click(function(e){
                  e.stopPropagation();
                });
              }
            }, 200);
          }
        });
      },

    overrides: function() {
      $(window).load(function() {
        setTimeout(function() {
          var i = 1;
          // - Betterbot
          $('img[src="https://dashboard.betterbot.ai/embed/images/close.png"]').attr('alt','betterbot close icon');
          $('img.betterbot_chat-btn').attr('alt','betterbot icon');
          // - Google recaptcha
          $("#g-recaptcha-response").attr({
            'aria-hidden': 'true',
            'aria-label': 'do not use',
            'aria-readonly': 'true'
          }).before('<label for="g-recaptcha-response" class="sr-only">reCaptcha</label>');
          $('.grecaptcha-logo iframe').attr('title','reCaptcha');
          // - Hy.ly
          $('#hy-frame-container').attr('title','Hy.ly Schedule A Tour');
          // - Date Picker
          $('.picker__day').removeAttr('aria-activedescendant');
          // - all iframes
          $('iframe').each(function(index) {
            if (!$(this).attr('title')) {
              $(this).attr('title', 'Embed ' + (++index));
            }
            $(this).removeAttr('frameborder').removeAttr('scrolling').removeAttr('width').removeAttr('height');
          });
          // - Google Map
          $('.gm-style img').each(function() {
            if (!$(this).attr('alt')) {
              $(this).attr('alt','Google Maps Icon ' + (++i));
            }
          });
        }, 500);
      });
    },

    init: function() {
      this.domCache();
      this.mobileNav();
      this.header();
      this.sidebar();
      this.pagination();
      this.filter();
      this.petPolicy();
      this.lightbox();
      this.lazyLoad();
      this.overrides();
    }
  };

  $(document).ready(init.init());

})(jQuery);

(function($) {
  if (typeof mapSettings != 'undefined' && typeof google === 'object' && typeof google.maps === 'object') {

    var map = {
      dom: function() {
        this.$mapCanvas           = $('#map_canvas');
        this.$zoomIn              = $('#zoom_in');
        this.$zoomOut             = $('#zoom_out');
        this.$refresh             = $('#refresh');
        this.$poiFilter           = $('[data-js-hook="poi-filter"]');
        this.$mainInfoBoxTemplate = $('#main-infobox-template');
        this.$infoBoxTemplate     = $('#infobox-template');
        this.$poiToggleBox        = $('[data-js-hook="toggle-poi-infobox"]');
        this.$poiCategory         = $('[data-js-hook="poi-category"]');
      },

      definitions: function() {
        // -- Probably don't want to touch.
        this.instance;
        this.mainInfoBox;
        this.poiMarkers    = [];
        this.assetPath     = config.siteUrl + mapSettings.assetPath.replace(/^\/|\/$/g, '') + '/';

        // -- You can touch.
        this.zoomIncrement   = 1;
        this.defaultCategory = mapSettings.defaultCategory;
        this.currentCategory = this.defaultCategory;
        this.homeImageFile   = 'map_home.png';
        this.dataEndpoint    = 'neighborhood';
        this.poiIconFormat   = '{{category}}_small';
        this.mainInfoboxHTML = this.$mainInfoBoxTemplate.html();
        this.poiInfoboxHTML  = this.$infoBoxTemplate.html();
        this.mapStyles = [
          {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [{
              "color": "#a5a19e"
            }]
          }, {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#f2f0f0"
            }]
          }, {
            "featureType": "landscape.man_made",
            "elementType": "labels",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "poi",
            "elementType": "labels.icon",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [{
              "color": "#afaba8"
            }]
          }, {
            "featureType": "road",
            "elementType": "labels.text.stroke",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#dfdcdb"
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [{
              "color": "#c2bebc"
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [{
              "color": "#787471"
            }]
          }, {
            "featureType": "road.arterial",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#dfdcdb"
            }]
          }, {
            "featureType": "road.arterial",
            "elementType": "geometry.stroke",
            "stylers": [{
              "color": "#cccccc"
            }]
          }, {
            "featureType": "road.local",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#dfdcdb"
            }]
          }, {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#dbe9f6"
            }]
          }];
      },

      onGoogleLoad: function(callback){
        var checkGoogle = setInterval(function() {
          if (typeof google == 'object') {
            clearInterval(checkGoogle);
            callback();
          }
        }, 100);
      },

      loadMap: function(event) {
        map.setOptions();
        map.googleMap = google.maps;
        map.instance = new map.googleMap.Map(map.$mapCanvas[0], map.mapOptions);
        map.bindControls();
        map.googleMap.event.addDomListener(window, 'resize', map.mapResize);

        // -- Place Home Marker
        var mainMarker = new map.googleMap.Marker({
          map: map.instance,
          position: map.latlng,
          icon : map.assetPath + map.homeImageFile
        });

        // -- Build InfoBox & Bind Toggle Controls
        map.mainInfoBox = $.extend(new InfoBox(map.pinpointOptions), {isMain: true});
        map.openMarker(map.mainInfoBox, mainMarker);
        map.bindMarkerOpen(map.mainInfoBox, mainMarker);

        // -- Draw all POIs to map
        mapSettings.pois.forEach(function(point){
          map.drawPoint(point);
        });

        map.poiVisibility(map.currentCategory, event && event.type == 'resize' ? true : false);
      },

      mapResize: function() {
        var boundry = new map.googleMap.LatLngBounds();

        map.poiMarkers.forEach(function(marker){
          if (marker.category == map.currentCategory) {
            boundry.extend(marker.position);
          }
        });

        if ($(window).width() >= 660){
          map.instance.fitBounds(boundry);
          map.instance.setZoom(map.instance.getZoom() - 1);
        } else if ($(window).width() < 660) {
          setTimeout(function(){
            var centerBoundry = new map.googleMap.LatLngBounds().extend(map.latlng);
            map.instance.fitBounds(centerBoundry);
            map.instance.setZoom(map.instance.getZoom() - 7);
          }, 100);
        }
      },

      drawPoint: function(point) {
        var poiInfoboxHTML = this.poiInfoboxHTML.replace(/\n/g, '');
        var poiOptions = this.poiOptions;
        var poiIcon = this.poiIconFormat.replace(/{{category}}/g, point.icon);

        // -- Parse If Statements
        if (ifStatement = /(\{\{if(.*?)\}\}(.*?)\{\{endif\}\})/g.exec(poiInfoboxHTML)) {
          var condition = ifStatement[2].trim();

          if (point[condition]){
            poiInfoboxHTML = poiInfoboxHTML.replace(ifStatement[1], ifStatement[3]);
          } else {
            poiInfoboxHTML = poiInfoboxHTML.replace(ifStatement[1], '');
          }
        }

        // -- Mustache Var Replace
        for (property in point) {
          var expression = new RegExp('({{' + property + '}})', 'g');
          if (poiInfoboxHTML.match(expression)) {
            poiInfoboxHTML = poiInfoboxHTML.replace(expression, point[property]);
          }
        }

        // -- Determine icon file extension. (.png if IE, .svg if not)
        if (navigator.userAgent.indexOf('rv:11') > -1 || navigator.userAgent.indexOf('MSIE') > -1){
          poiIcon += '.png';
        } else {
          poiIcon += '.svg';
        }

        // -- Draw point onto map.
        var poiMarker = new this.googleMap.Marker({
          map: map.instance,
          position: new this.googleMap.LatLng(point.lat, point.lng),
          icon : map.assetPath + poiIcon
        });

        // -- Push marker into array & bind
        this.poiMarkers.push($.extend(poiMarker, {
          category: point.category,
          id: point.id
        }));

        this.bindMarkerOpen(new InfoBox($.extend(poiOptions, {content: poiInfoboxHTML})), poiMarker);
      },

      poiVisibility: function(category, centerOnPoints) {
        var self = this;
        var boundry = new this.googleMap.LatLngBounds();

        // -- Close all InfoBoxes except Main
        if (this.openWindow && !this.openWindow.isMain) {
          this.openWindow.close();
        }

        // -- Hide everything not matching passed-in category
        this.poiMarkers.forEach(function(marker){
          marker.setVisible(false);

          if (marker.category == category) {
            boundry.extend(marker.position);
            marker.setVisible(true);
          }
        });

        if (centerOnPoints && $(window).width() >= 660){
          this.instance.fitBounds(boundry);
          this.instance.setZoom(this.instance.getZoom() - 1);
        } else if ($(window).width() < 660) {
          var centerBoundry = new this.googleMap.LatLngBounds().extend(this.latlng);

          setTimeout(function(){
            self.instance.fitBounds(centerBoundry);
            self.instance.setZoom(self.instance.getZoom() - 7);
          }, 100);
        }
      },

      bindMarkerOpen: function(infoBoxObject, markerObject) {
        var self = this;
        this.bindTogglePoiInfobox(infoBoxObject, markerObject);
        this.googleMap.event.addListener(markerObject, 'click', function(){
          self.openWindow.close();
          self.openMarker(infoBoxObject, markerObject);
        });
      },

      openMarker: function(infoBoxObject, markerObject, callback) {
        // -- Close all InfoBoxes except Main
        if (this.openWindow && !this.openWindow.isMain) {
          this.openWindow.close();
        }

        // -- Open new InfoBox
        var $listingItem = this.$poiToggleBox.filter('[data-poi-id=' + markerObject.id + ']');
        infoBoxObject.open(this.instance, markerObject);
        this.$poiToggleBox.removeClass('neighborhood__poi-category-link--active');
        $listingItem.addClass('neighborhood__poi-category-link--active');
        this.openWindow = infoBoxObject;

        if ($listingItem.parent().data('js-hook') == 'poi-hidden' && !$listingItem.parent().is(':visible')) {
          $('#load-all-poi').trigger('click');
        }
      },

      bindControls: function() {
        var self = this;

        // -- Adjust POI Visibility when selecting a filter
        this.$poiFilter.first().attr('data-selected', true);

        this.$poiFilter.click(function(e){
          e.preventDefault();

          self.currentCategory = $(this).data('poi');
          self.poiVisibility(self.currentCategory, true);
        });

        // -- Map click closes all windows
        this.googleMap.event.addListener(self.instance, 'click', function(){
          self.mainInfoBox.close();
          if (self.openWindow) {
            self.openWindow.close();
          }
        });

        // -- Zoom In Control
        this.$zoomIn.unbind().click(function(e){
          e.preventDefault();
          self.instance.setZoom(self.instance.getZoom() + self.zoomIncrement);
        });

        // -- Zoom Out Control
        this.$zoomOut.unbind().click(function(e){
          e.preventDefault();
          self.instance.setZoom(self.instance.getZoom() - self.zoomIncrement);
        });

        // -- Refresh Control
        this.$refresh.unbind().click(function(e){
          e.preventDefault();
          self.currentCategory = self.defaultCategory;
          self.loadMap();
        });
      },

      bindTogglePoiInfobox: function(infoBoxObject, markerObject) {
        var self = this;
        var togglePoiActiveClass = 'neighborhood__poi-category-link--active';
        this.$poiToggleBox.filter('[data-poi-id=' + markerObject.id + ']').click(function(e){
          e.preventDefault();
          if ($(window).width() >= 808) {
            self.poiVisibility(markerObject.category);
            self.openWindow.close();
            self.openMarker(infoBoxObject, markerObject);
            self.$poiToggleBox.removeClass(self.poiActiveClass);
            $(this).addClass(self.poiActiveClass);
            self.instance.panTo(new self.googleMap.LatLng(markerObject.position.lat(), markerObject.position.lng()));
            $('html, body').stop().animate({
              scrollTop: self.$mapCanvas.offset().top
            }, 300);
          }
        });
      },

      setOptions: function(){
        this.latlng = new google.maps.LatLng(mapSettings.lat, mapSettings.lng);

        // -- Point of Interest Infobox Options Object
        this.poiOptions = {
          content: null, // -- Set by drawPoint
          disableAutoPan: false,
          alignBottom: true,
          maxWidth: 0,
          pixelOffset: new google.maps.Size(0, -30),
          zIndex: null,
          boxClass: "map__infobox",
          infoBoxClearance: new google.maps.Size(1, 1),
          isHidden: false,
          pane: "floatPane",
          enableEventPropagation: true
        };

        // -- Pinpoint Infobox Options Object
        this.pinpointOptions = {
          content: this.mainInfoboxHTML,
          disableAutoPan: false,
          maxWidth: 0,
          pixelOffset: new google.maps.Size(-71, -160),
          zIndex: 9999,
          boxStyle: {},
          boxClass: "map__infobox",
          closeBoxMargin: "-20px 43px 0 0",
          closeBoxURL: "",
          infoBoxClearance: new google.maps.Size(1, 1),
          isHidden: false,
          pane: "floatPane",
          enableEventPropagation: true
        };

        // -- Map Options Object
        this.mapOptions = {
          zoom: 14,
          minZoom: 5,
          maxZoom: 25,
          scrollwheel:false,
          center: this.latlng,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          mapTypeControl: false,
          disableDefaultUI: true,
          styles: this.mapStyles
        };
      },

      init: function() {
        this.dom();
        this.definitions();
        this.onGoogleLoad(this.loadMap);
      }
    }

    $(function(){
      map.init();
    });
  }

})(jQuery);

(function($){
  'use strict';

  var modal = {
    dom: function() {
      this.$modalToggle = $('[data-toggle="modal"]');
      this.$modal = $('[data-js-hook="modal"]');
      this.$close = $('[data-dismiss="modal"]');
    },

    showHideModal: function() {
      var self = this;

      this.$modalToggle.click(function(e) {
        e.preventDefault();
        var target = $(this).data('target');
        var embed = $(target).find('.modal__iframe-wrap');
        if ($(target).is(':visible')) {
          $(target).fadeOut();
          $('html').css('overflow','');
        }
        else {
          if (embed.length) {
            embed.append(decodeURIComponent(embed.data('embed-code')));
            setTimeout(function() {
              $('.modal__loading', $(target)).fadeOut();
            }, 2000);
          }
          else {
            $('.modal__loading', $(target)).fadeOut();
          }
          self.$modal.fadeOut();
          $(target).fadeIn();
          $('html').css('overflow','hidden');
        }
      });
    },

    closeModal: function() {
      this.$close.click(function(e) {
        e.preventDefault();
        var $target = $(this).closest('.modal');
        $target.fadeOut();
        $('html').css('overflow','');
      });
    },

    ready: function() {
      this.dom();
      this.showHideModal();
      this.closeModal();
    }
  };

  $(function() { modal.ready(); });

})(jQuery);

(function($){
  'use strict';

  if ($('html').hasClass('page-news')) {

    var news = {
      filterDom: function() {
        if ($(window).width() > 808) {
          $('.filter').prependTo('#page');
        }
        else {
          $('.filter').insertBefore('#filter-results-container');
        }
      },

      init: function() {
        this.filterDom();
      }
    };

    $(window).on('load resize', function() {
      news.init();
    });

  }

})(jQuery);

(function($) {
  'use strict';

  var shareThis = {
    dom: function() {
      this.shareContainer = $('#share-this-popup');
      this.shareLink = $('#share-link');
      this.shareLoader = $('#share-loader');
    },

    settings: function() {
      this.activeClass = 'share-this-popup--show';
    },

    setupShareThis: function() {
      var self = this;

      this.shareContainer.data('loaded', '0');

      this.shareLink.on('click',function(e) {
        e.preventDefault();
        e.stopPropagation();

        //If we don't have any Share This content on the page already, fetch it via AJAX
        if (self.shareContainer.data('loaded') == '0') {
          //indicate that it's loading...
          self.shareLoader.show();
          self.shareLink.css('opacity', 0);

          //mark Share This as loaded so we won't load it via AJAX again unless page is refreshed
          self.shareContainer.data('loaded', '1');

          //If user overrode defaults in the HTML markup, use the override values here
          var sUrl = self.shareContainer.data('url') || '';
          var sTweetFilter = self.shareContainer.data('tweet-filter') || 'GLOBAL';
          var sEmailFilter = self.shareContainer.data('email-filter') || 'GLOBAL';
          var iPropertyID = self.shareContainer.data('property') || '';

          //fetch the Share This content via AJAX
          self.shareContainer.load(self.shareContainer.data('script'), { 'url': sUrl, 'email_filter': sEmailFilter, 'tweet_filter': sTweetFilter, 'property': iPropertyID }, function() {
            self.shareContainer.addClass(self.activeClass);
            //remove the loading indicator
            self.shareLoader.hide();
            self.shareLink.css('opacity', 1);
          });
        }
        else {
          //We've already fetched Share This content for this page, so just show it
          self.shareContainer.toggleClass(self.activeClass);
        }
      });

      $('body').click(function() {
        //if the "SHARE" tooltip is visible, then close it
        if (self.shareContainer.hasClass(self.activeClass)) {
          self.shareContainer.toggleClass(self.activeClass);
        }
      });
    },

    ready: function() {
      this.dom();
      this.settings();
      this.setupShareThis();
    }
  };

  $(function() { shareThis.ready(); });

})(jQuery);

(function($){
  'use strict';

  if ($('html').hasClass('page-staff')) {

    var staff = {
      dom: function() {
        this.$staffFilter  = $('#departmentSelect');
        this.$filterSelect = $('#department-select');
        this.$department   = $('[data-js-hook="department"]');
        this.$staff        = $('[data-js-hook="staffMember"]');
        this.$staffContent = $('#staffContent');
        this.$staffLoader  = $('.staff__loading');
        this.$loader       = $('.modal__loader');
      },

      departmentSelect: function() {
        var self = this;

        this.$filterSelect.on('change', function() {
          self.$staffFilter.submit();
        });

        this.$staffFilter.on('submit', function(e) {
          e.preventDefault();
          self.$staffLoader.fadeIn(100);
          var id = self.$filterSelect.val();
          if (id != '') {
            $('.page__select-reset').show();
            self.$department.hide();
            $('[data-id="group' + id + '"]').show();
          }
          else {
            $('.page__select-reset').hide();
            self.$department.show();
          }

          $('.wow').css({
            'visibility' : 'visible',
            'animation-name' : 'none'
          }).removeClass('wow fadeInUp');
          setTimeout(function() {
            self.$staffLoader.fadeOut(200);
          }, 500);
        });

        $('.page__select-reset').click(function() {
          self.$staffFilter.find('select, input, textarea').val('');
          self.$staffFilter.submit();
        });
      },

      staffModal: function() {
        var self = this;

        this.$staff.click(function(e) {
          e.preventDefault();

          var target = $(this).attr('href');
          if (target.length) {
            self.$staffContent.load(target, function() {
              self.$staffContent.scrollTop(0);
              self.$loader.hide();
            });
          }
        });
      },

      ready: function() {
        this.dom();
        this.departmentSelect();
        this.staffModal();
      }
    };

    $(function() { staff.ready(); });
  }

})(jQuery);

(function($) {
  'use strict';

  if ($('html').hasClass('page-what-we-do')) {

    var whatWeDo = {
      domCache: function() {
        this.$expandDesc = $('[data-js-hook="expand-desc"]');
        this.$fullDesc = $('#expand-desc_' + this.$expandDesc.attr('data-id'));
      },

      expandDesc: function() {
        this.$expandDesc.on('click', function(e){
          e.preventDefault();
          var dataId = $(this).data('id');
          $('#expand-desc_' + dataId).toggle();
          $(this).text($(this).text() == '... Read More' ? '... Less' : '... Read More');
        });
      },

      init: function() {
        this.domCache();
        this.expandDesc();
      }
    };

    $(function() {
      whatWeDo.init();
    });

  }

})(jQuery);

//# sourceMappingURL=custom.js.map
